import api from "../../config/client.axios.api";

export const updateFrameMachineApi = async (infoUpdate: any) => {
  const response = await api.put(`/machine/update-frame`, infoUpdate);
  return response.data;
};

